import React from 'react';
import {
  Form, Input, Button, Space, Checkbox, Alert,
} from 'antd';
import { UserOutlined, LockOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';

import RecoveryPassword from '../RecoveryPassword';
import useLoginForm from './useLoginForm';

const { Item } = Form;

function LoginForm() {

  const { requestLogin, loading, error } = useLoginForm();
  const { t } = useTranslation();

  return (
    <Form onFinish={requestLogin}>
      <Item
        name="username"
        rules={[{ required: true, message: t('forms.login.feedbacks.username_req') }]}
      >
        <Input
          size="large"
          prefix={<UserOutlined />}
          placeholder={t('forms.login.placeholders.username')}
        />
      </Item>

      <Item
        name="password"
        rules={[{ required: true, message: t('forms.login.feedbacks.password_req') }]}
      >
        <Input.Password
          size="large"
          prefix={<LockOutlined />}
          placeholder={t('forms.login.placeholders.password')}
        />
      </Item>

      <Space align="start">
        <Item name="remember" valuePropName="checked">
          <Checkbox>{t('forms.login.placeholders.remember_user')}</Checkbox>
        </Item>
        <RecoveryPassword />
      </Space>

      {error && !loading && (
        <Alert style={{ marginBottom: 20 }} message={error} type="error" showIcon />
      )}

      <Item>
        <Button type="primary" htmlType="submit" size="large" block loading={loading}>
          {t('forms.login.buttons.login')}
        </Button>
      </Item>
    </Form>
  );

}

export default LoginForm;
